import { render } from "./SerproStatus.vue?vue&type=template&id=0a707e39"
import script from "./SerproStatus.vue?vue&type=script&lang=js"
export * from "./SerproStatus.vue?vue&type=script&lang=js"

import "./styles.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__